<template>
  <div>
    <div v-if="show" class="pay-dialog-shadow" @click="closePayDialog"></div>
    <div v-if="show" class="pay-dialog">
      <div class="pay-dialog-title">
        <div class="pay-dialog-icon">i</div>
        <div>您确定要退出登录吗？</div>
      </div>
      <div class="pay-dialog-btn">
        <div class="btn cancel" @click="closePayDialog">取消</div>
        <div class="btn confirm" @click="doLogOut">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerService',
  props: {
    // 类型检查
    openLogout: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    openLogout(val) {
      this.show = val
    }
  },
  data() {
    return {
      show: this.openLogout
    }
  },
  methods: {
    closePayDialog() {
      this.$emit('reset')
    },
    doLogOut() {
      this.$emit('logout')
    }
  }

}
</script>


<style scoped>
.pay-dialog-shadow {
  width: 99.99%;
  height: 100vh;
  z-index: 2001;
  position: absolute;
  top: 0;
  left: 0;
}

.pay-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -90px;
  margin-left: -170px;
  z-index: 2002;
  width: 340px;
  height: 180px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 14px 2px rgba(0, 0, 0, 0.05), 0px 8px 10px 1px rgba(0, 0, 0, 0.06), 0px 5px 5px -3px rgba(0, 0, 0, 0.1);
}

.pay-dialog-title {
  margin: 32px 0 69px 30px;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 22px;
  color: rgba(51, 51, 51, 0.9);
}

.pay-dialog-icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: rgba(255, 87, 51, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-right: 9px;
}

.pay-dialog-btn {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.btn {
  width: 56px;
  height: 32px;
  border-radius: 3px;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 28px;
}
.cancel {
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(63, 140, 255, 1);
  color: rgba(51, 51, 51, 1);
}
.confirm {
  background: rgba(63, 140, 255, 1);
  color: rgba(255, 255, 255, 1);
  margin: 0 25px 0 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/logout/index.vue